import { render, staticRenderFns } from "./opea.vue?vue&type=template&id=37925de2&scoped=true"
import script from "./opea.vue?vue&type=script&lang=js"
export * from "./opea.vue?vue&type=script&lang=js"
import style0 from "./opea.vue?vue&type=style&index=0&id=37925de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37925de2",
  null
  
)

export default component.exports